import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'cva';
import { type ComponentProps, type FunctionComponent } from 'react';
import styles from './Link.module.css';

const variant = cva({
  base: styles.root,
});

export type LinkProps = ComponentProps<'a'> &
  VariantProps<typeof variant> & {
    asChild?: boolean;
  };

export const Link: FunctionComponent<LinkProps> = ({
  asChild,
  className,
  ref,
  type,
  ...props
}) => {
  const Comp = asChild ? Slot : 'a';

  return (
    <Comp className={variant({ className })} ref={ref} type={type} {...props} />
  );
};

Link.displayName = 'Link';
